import { render, staticRenderFns } from "./ReceiPt.vue?vue&type=template&id=27bc06ae&scoped=true&"
import script from "./ReceiPt.vue?vue&type=script&lang=js&"
export * from "./ReceiPt.vue?vue&type=script&lang=js&"
import style0 from "./ReceiPt.vue?vue&type=style&index=0&id=27bc06ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc06ae",
  null
  
)

export default component.exports